export default __webpack_public_path__ + "static/media/Cover_Client_B2B.d5fad3e0.jpg";